import { useEffect } from 'react'
import { getShopId, queryClient, useTranslate } from 'utils'
import { useField } from 'react-final-form'
import { FormRemove } from 'components/form-remove/form-remove'
import { useNavigate } from 'react-router-dom'
import { useRemoveService } from 'api'
import { message } from 'antd'

export const ServiceRemove = () => {

    //translate:
    const { __ } = useTranslate()

    //navigation:
    const navigate = useNavigate()

    //field:
    const { input: { value: id } } = useField('id')

    //mutation:
    const { mutate, isLoading, data: response } = useRemoveService(id)

    //after remove:
    useEffect(() => {
        if(response){
            queryClient.invalidateQueries(['services', getShopId()])
            navigate('/service')
            message.success(__`service_removed`)
        }
    }, [isLoading])
    
    return (
        <FormRemove
            title={__`remove_service`}
            message={__`all_settings_will_be_deleted_this_action_cant_be_undone`}
            description={__`this_will_not_remove_the_product_from_your_store`}
            isLoading={isLoading}
            onRemove={mutate}
        />
    )

}
